import React from 'react';
import cx from 'classnames';
import { FormattedMessage } from 'react-intl';
import speed from 'utils/images/asic-auto-tune.gif';
import hexColoredSmall from 'utils/images/hex-colored-small.svg';
import WL from 'constants/whiteLabel';
import gs from 'pages/pages.module.css';
import s from 'pages/homeStyles.module.css';
import style from './speed.module.css';

const Speed = () => (
  <section className={cx(style.root, gs.content, s.hiveosContent)}>
    {WL.showHexImg ? <img alt="hex" className={cx(s.drop1, s.__oneSolution)} src={hexColoredSmall} /> : null}
    <div className={gs.backgroundHeader}>speed</div>
    <div className={cx(gs.wrapper, s.wrapper)}>
      <div className={gs.relative}>
        <div className={style.transfromToLeft}>
          <img className={s.screen} src={speed} alt="speed" />
        </div>
      </div>
      <div className={style.text}>
        <h2><FormattedMessage id="Speed.title" defaultMessage="Speed-up worn ASIC chips" /></h2>
        <div>
          <FormattedMessage id="Speed.caption1" defaultMessage="Chip auto-tuning finds problematic or heavily worn chips and adjusts their frequencies." />
        </div>
        <div>
          <FormattedMessage id="Speed.caption2" defaultMessage="Automatically lowers frequencies on damaged chips to consume less power and prolong chip lifespan." />
        </div>
      </div>
    </div>
  </section>
)

export default Speed;
